// import React, { useState, useEffect } from 'react';
// import { useMutation, useQueryClient, useQuery } from 'react-query';
// import { useParams, useNavigate } from 'react-router-dom';
// import { createItem, updateItem, getItemById } from '../../../api/item';
// import { getSubcategories } from '../../../api/subcategory';
// import {
//   Box,
//   Button,
//   VStack,
//   FormControl,
//   FormLabel,
//   Input,
//   Textarea,
//   Text,
//   NumberInput,
//   NumberInputField,
//   Select,
//   Spinner,
//   Alert,
//   AlertIcon,
//   AlertTitle,
//   AlertDescription,
//   useToast,
// } from '@chakra-ui/react';
// import { useForm } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';

// const schema = yup.object().shape({
//   name: yup.string().required('Name is required'),
//   description: yup.string().required('Description is required'),
//   startPrice: yup.number().required('Start Price is required').min(0, 'Start Price must be a positive number'),
//   minBidIncrement: yup.number().required('Minimum Bid Increment is required').min(0, 'Minimum Bid Increment must be a positive number'),
//   deposit: yup.number().required('Deposit is required').min(0, 'Deposit must be a positive number'),
//   numberofitem: yup.number().required('Number of Items is required').min(1, 'There must be at least one item'),
//   startDate: yup.date().required('Start Date is required'),
//   endDate: yup.date().required('End Date is required'),
//   subcategoryId: yup.string().required('Subcategory is required'),
//   coverphoto: yup.mixed().required('Cover photo is required'),
//   thubnailphoto: yup.mixed().required('Thumbnail photo is required'),
// });

// const ItemForm = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const queryClient = useQueryClient();
//   const [imagePreview, setImagePreview] = useState({ cover: null, thumbnail: null });
//   const [initialImages, setInitialImages] = useState({ cover: null, thumbnail: null });
//   const toast = useToast();
//   const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm({
//     resolver: yupResolver(schema),
//   });

//   const { data: subcategories } = useQuery('subcategories', getSubcategories);

//   const { data: item, isLoading, error } = useQuery(['item', id], () => getItemById(id), {
//     enabled: !!id,
//     onSuccess: (data) => {
//       const itemData = data?.data;
//       setValue('name', itemData.name);
//       setValue('description', itemData.description);
//       setValue('startPrice', itemData.startPrice);
//       setValue('minBidIncrement', itemData.minBidIncrement);
//       setValue('deposit', itemData.deposit);
//       setValue('numberofitem', itemData.numberofitem);
//       setValue('startDate', itemData.startDate);
//       setValue('endDate', itemData.endDate);
//       setValue('subcategoryId', itemData.subcategoryId);
//       setInitialImages({
//         cover: `http://localhost:9000/${itemData.coverphoto.path}`,
//         thumbnail: `http://localhost:9000/${itemData.thubnailphoto.path}`,
//       });
//       setImagePreview({
//         cover: `http://localhost:9000/${itemData.coverphoto.path}`,
//         thumbnail: `http://localhost:9000/${itemData.thubnailphoto.path}`,
//       });
//     },
//   });

//   const mutation = useMutation(id ? (data) => updateItem(id, data) : createItem, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('items');
//       navigate('/dashboard/items');
//       toast({
//         title: `Item ${id ? 'updated' : 'created'} successfully`,
//         status: 'success',
//         duration: 3000,
//         isClosable: true,
//       });
//     },
//     onError: (error) => {
//       const errorMessage = error.response?.data?.message;
//       toast({
//         title: 'Error',
//         description: errorMessage || 'Something went wrong',
//         status: 'error',
//         duration: 3000,
//         isClosable: true,
//       });
//     },
//   });

//   const onSubmit = (data) => {
//     const formData = new FormData();
//     Object.keys(data).forEach((key) => {
//       if (key === 'coverphoto' || key === 'thubnailphoto') {
//         formData.append(key, data[key][0]);
//       } else {
//         formData.append(key, data[key]);
//       }
//     });
//     mutation.mutate(formData);
//   };

//   const handleImageChange = (e) => {
//     const { id, files } = e.target;
//     if (files[0]) {
//       setImagePreview((prev) => ({ ...prev, [id]: URL.createObjectURL(files[0]) }));
//     }
//   };

//   if (isLoading) {
//     return (
//       <Box textAlign="center" py={10} px={6}>
//         <Spinner size="xl" />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box textAlign="center" py={10} px={6}>
//         <Alert status="error">
//           <AlertIcon />
//           <AlertTitle>Error:</AlertTitle>
//           <AlertDescription>{error.message}</AlertDescription>
//         </Alert>
//       </Box>
//     );
//   }

//   return (
//     <Box maxW="md" mx="auto" p={6} borderWidth={1} borderRadius="md" boxShadow="lg">
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <VStack spacing={4}>
//           <FormControl isInvalid={errors.name}>
//             <FormLabel htmlFor="name">Name</FormLabel>
//             <Input id="name" {...register('name')} />
//             {errors.name && <Text color="red.500">{errors.name.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.description}>
//             <FormLabel htmlFor="description">Description</FormLabel>
//             <Textarea id="description" {...register('description')} />
//             {errors.description && <Text color="red.500">{errors.description.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.startPrice}>
//             <FormLabel htmlFor="startPrice">Start Price</FormLabel>
//             <NumberInput min={0}>
//               <NumberInputField id="startPrice" {...register('startPrice')} />
//             </NumberInput>
//             {errors.startPrice && <Text color="red.500">{errors.startPrice.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.minBidIncrement}>
//             <FormLabel htmlFor="minBidIncrement">Minimum Bid Increment</FormLabel>
//             <NumberInput min={0}>
//               <NumberInputField id="minBidIncrement" {...register('minBidIncrement')} />
//             </NumberInput>
//             {errors.minBidIncrement && <Text color="red.500">{errors.minBidIncrement.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.deposit}>
//             <FormLabel htmlFor="deposit">Deposit</FormLabel>
//             <NumberInput min={0}>
//               <NumberInputField id="deposit" {...register('deposit')} />
//             </NumberInput>
//             {errors.deposit && <Text color="red.500">{errors.deposit.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.numberofitem}>
//             <FormLabel htmlFor="numberofitem">Number of Items</FormLabel>
//             <NumberInput min={1}>
//               <NumberInputField id="numberofitem" {...register('numberofitem')} />
//             </NumberInput>
//             {errors.numberofitem && <Text color="red.500">{errors.numberofitem.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.subcategoryId}>
//             <FormLabel htmlFor="subcategoryId">Subcategory</FormLabel>
//             <Select id="subcategoryId" {...register('subcategoryId')}>
//               {subcategories?.data?.data.map((subcategory) => (
//                 <option key={subcategory._id} value={subcategory._id}>
//                   {subcategory.name}
//                 </option>
//               ))}
//             </Select>
//             {errors.subcategoryId && <Text color="red.500">{errors.subcategoryId.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.startDate}>
//             <FormLabel htmlFor="startDate">Start Date</FormLabel>
//             <Input type="date" id="startDate" {...register('startDate')} />
//             {errors.startDate && <Text color="red.500">{errors.startDate.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.endDate}>
//             <FormLabel htmlFor="endDate">End Date</FormLabel>
//             <Input type="date" id="endDate" {...register('endDate')} />
//             {errors.endDate && <Text color="red.500">{errors.endDate.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.coverphoto}>
//             <FormLabel htmlFor="coverphoto">Cover Photo</FormLabel>
//             {imagePreview.cover && (
//               <Box mb={4}>
//                 <img src={imagePreview.cover} alt="Cover Preview" width="100%" />
//               </Box>
//             )}
//             <Input type="file" id="coverphoto" {...register('coverphoto')} onChange={handleImageChange} />
//             {errors.coverphoto && <Text color="red.500">{errors.coverphoto.message}</Text>}
//           </FormControl>

//           <FormControl isInvalid={errors.thubnailphoto}>
//             <FormLabel htmlFor="thubnailphoto">Thumbnail Photo</FormLabel>
//             {imagePreview.thumbnail && (
//               <Box mb={4}>
//                 <img src={imagePreview.thumbnail} alt="Thumbnail Preview" width="100%" />
//               </Box>
//             )}
//             <Input type="file" id="thubnailphoto" {...register('thubnailphoto')} onChange={handleImageChange} />
//             {errors.thubnailphoto && <Text color="red.500">{errors.thubnailphoto.message}</Text>}
//           </FormControl>

//           <Button type="submit" colorScheme="blue" width="full">
//             {id ? 'Update Item' : 'Create Item'}
//           </Button>
//         </VStack>
//       </form>
//     </Box>
//   );
// };

// export default ItemForm;



import React, { useState, useEffect } from 'react';
import { useMutation, useQueryClient, useQuery } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { createItem, updateItem, getItemById } from '../../../api/item';
import { getSubcategories } from '../../../api/subcategory';
import {
  Box,
  Button,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Text,
  NumberInput,
  NumberInputField,
  Select,
  Spinner,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useToast,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Api from '../../../api/ApiUrl'

const schema = yup.object().shape({
  name: yup.string().required('Name is required'),
  description: yup.string().required('Description is required'),
  startPrice: yup.number().required('Start Price is required').min(0, 'Start Price must be a positive number'),
  minBidIncrement: yup.number().required('Minimum Bid Increment is required').min(0, 'Minimum Bid Increment must be a positive number'),
  deposit: yup.number().required('Deposit is required').min(0, 'Deposit must be a positive number'),
  numberofitem: yup.number().required('Number of Items is required').min(1, 'There must be at least one item'),
  startDate: yup.date().required('Start Date is required'),
  endDate: yup.date().required('End Date is required'),
  subcategoryId: yup.string().required('Auctions is required'),
  coverphoto: yup.mixed().required('Cover photo is required'),
  thubnailphoto: yup.mixed().required('Thumbnail photo is required'),
});

const ItemForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [imagePreview, setImagePreview] = useState({ cover: null, thumbnail: null });
  const [initialImages, setInitialImages] = useState({ cover: null, thumbnail: null });
  const toast = useToast();
  const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm({
    resolver: yupResolver(schema),
  });

  const { data: subcategories } = useQuery('subcategories', getSubcategories);

  const { data: item, isLoading, error } = useQuery(['item', id], () => getItemById(id), {
    enabled: !!id,
    onSuccess: (data) => {
      console.log('item', item)
      const itemData = data?.data?.data;
      setValue('name', itemData.name);
      setValue('description', itemData.description);
      setValue('startPrice', itemData.startPrice);
      setValue('minBidIncrement', itemData.minBidIncrement);
      setValue('deposit', itemData.deposit);
      setValue('numberofitem', itemData.numberofitem);
      setValue('startDate', itemData.startDate.slice(0, 16));
      setValue('mainlystartPrice', itemData.mainlystartPrice.slice(0, 16));

      setValue('endDate', itemData.endDate.slice(0, 16));
      setValue('subcategoryId', itemData.subcategoryId?.id);
      setInitialImages({
        cover: `${Api}/${itemData?.coverphoto?.path}`,
        thumbnail: `${Api}/${itemData?.thubnailphoto?.path}`,
      });
      setImagePreview({
        cover: `${Api}/${itemData?.coverphoto?.path}`,
        thumbnail: `${Api}/${itemData?.thubnailphoto?.path}`,
      });
    },
  });

  const mutation = useMutation(id ? (data) => updateItem(id, data) : createItem, {
    onSuccess: () => {
      queryClient.invalidateQueries('items');
      navigate('/dashboard/admin/items');
      toast({
        title: `Item ${id ? 'updated' : 'created'} successfully`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    },
    onError: (error) => {
      console.error(error);
      const errorMessage = error.response?.data?.message;
      const errorsArray = error.response?.data?.errors;

      if (errorsArray && Array.isArray(errorsArray)) {
        errorsArray.forEach((err) => {
          toast({
            title: 'Error',
            description: err.msg,
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        });
      } else if (errorMessage) {
        toast({
          title: 'Error',
          description: errorMessage,
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: 'Error',
          description: 'An error occurred while creating the item.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    },
  });

  const onSubmit = (data) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (key === 'coverphoto' || key === 'thubnailphoto') {
        formData.append(key, data[key][0]);
      } else {
        formData.append(key, data[key]);
      }
    });
    mutation.mutate(formData);
  };

  const handleImageChange = (e) => {
    const { id, files } = e.target;
    if (files[0]) {
      setImagePreview((prev) => ({ ...prev, [id]: URL.createObjectURL(files[0]) }));
    }
  };

  if (isLoading) {
    return (
      <Box textAlign="center" py={10} px={6}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box textAlign="center" py={10} px={6}>
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>Error:</AlertTitle>
          <AlertDescription>{error.message}</AlertDescription>
        </Alert>
      </Box>
    );
  }

  return (
    <Box maxW="md" mx="auto" p={6} borderWidth={1} borderRadius="md" boxShadow="lg">
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack spacing={4}>
          <FormControl isInvalid={errors.name}>
            <FormLabel htmlFor="name">Name</FormLabel>
            <Input id="name" {...register('name')} />
            {errors.name && <Text color="red.500">{errors.name.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.description}>
            <FormLabel htmlFor="description">Description</FormLabel>
            <Textarea id="description" {...register('description')} />
            {errors.description && <Text color="red.500">{errors.description.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.startPrice}>
            <FormLabel htmlFor="startPrice">Start Price</FormLabel>
            <NumberInput min={0}>
              <NumberInputField id="startPrice" {...register('startPrice')} />
            </NumberInput>
            {errors.startPrice && <Text color="red.500">{errors.startPrice.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.minBidIncrement}>
            <FormLabel htmlFor="minBidIncrement">Minimum Bid Increment</FormLabel>
            <NumberInput min={0}>
              <NumberInputField id="minBidIncrement" {...register('minBidIncrement')} />
            </NumberInput>
            {errors.minBidIncrement && <Text color="red.500">{errors.minBidIncrement.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.deposit}>
            <FormLabel htmlFor="deposit">Deposit</FormLabel>
            <NumberInput min={0}>
              <NumberInputField id="deposit" {...register('deposit')} />
            </NumberInput>
            {errors.deposit && <Text color="red.500">{errors.deposit.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.numberofitem}>
            <FormLabel htmlFor="numberofitem">Number of Items</FormLabel>
            <NumberInput min={1}>
              <NumberInputField id="numberofitem" {...register('numberofitem')} />
            </NumberInput>
            {errors.numberofitem && <Text color="red.500">{errors.numberofitem.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.subcategoryId}>
            <FormLabel htmlFor="subcategoryId">Subcategory</FormLabel>
            <Select id="subcategoryId" {...register('subcategoryId')}>
              {subcategories?.data?.data.map((subcategory) => (
                <option key={subcategory._id} value={subcategory._id}>
                  {subcategory.name}
                </option>
              ))}
            </Select>
            {errors.subcategoryId && <Text color="red.500">{errors.subcategoryId.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.startDate}>
            <FormLabel htmlFor="startDate">Start Date</FormLabel>
            <Input type="datetime-local" id="startDate" {...register('startDate')} />
            {errors.startDate && <Text color="red.500">{errors.startDate.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.endDate}>
            <FormLabel htmlFor="endDate">End Date</FormLabel>
            <Input type="datetime-local" id="endDate" {...register('endDate')} />
            {errors.endDate && <Text color="red.500">{errors.endDate.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.coverphoto}>
            <FormLabel htmlFor="coverphoto">Cover Photo</FormLabel>
            <Input type="file" id="coverphoto" accept="image/*" {...register('coverphoto')} onChange={handleImageChange} />
            {imagePreview.cover && <img src={imagePreview.cover} alt="Cover Preview" style={{ marginTop: '10px', maxHeight: '200px' }} />}
            {errors.coverphoto && <Text color="red.500">{errors.coverphoto.message}</Text>}
          </FormControl>

          <FormControl isInvalid={errors.thubnailphoto}>
            <FormLabel htmlFor="thubnailphoto">Thumbnail Photo</FormLabel>
            <Input type="file" id="thubnailphoto" accept="image/*" {...register('thubnailphoto')} onChange={handleImageChange} />
            {imagePreview.thumbnail && <img src={imagePreview.thumbnail} alt="Thumbnail Preview" style={{ marginTop: '10px', maxHeight: '200px' }} />}
            {errors.thubnailphoto && <Text color="red.500">{errors.thubnailphoto.message}</Text>}
          </FormControl>

          <Button isLoading={mutation.isLoading} type="submit" colorScheme="blue" isFullWidth>
            {id ? 'Update Item' : 'Create Item'}
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default ItemForm;
